module.exports = __webpack_public_path__ + "img/T908.c429d90e.jpg";